import LoadingButton from '@mui/lab/LoadingButton';

type FullWidthButtonProps = {
  isCalculating: boolean;
  neverCalculated: boolean;
  isLoading: boolean;
  onCalculateOrRefresh: () => void;
};

export const FullWidthButton = ({
  isCalculating,
  neverCalculated,
  isLoading,
  onCalculateOrRefresh,
}: FullWidthButtonProps) => {
  if (isCalculating || !neverCalculated) {
    return null;
  }

  return (
    <LoadingButton
      variant='contained'
      onClick={onCalculateOrRefresh}
      loading={isLoading}
      disabled={isLoading || isCalculating}
      fullWidth
    >
      Calculate Now
    </LoadingButton>
  );
};
